import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pertest",
  "use": "icon-pertest-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-pertest\"><path d=\"M916.98 748.973l-0.658-555.705-810.582 0.996-0.739 554.366v0.525l-75.642-0.051v69.314h961.744l0.061-69.287-74.183-0.159zM843.145 749.263l-4.489-0.020h-661.412l0.815-486.892 665.116 0.705-0.025 486.208z\" p-id=\"7022\" /><path d=\"M400.726 515.349l149.246 134.11 207.683-184.14-47.085-47.084-159.757 147.984-151.558-133.481-124.863 116.034 40.991 44.775 85.344-78.194z\" p-id=\"7023\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pertest.svg
// module id = 15TM
// module chunks = 77